export function useThrowError() {
  const throwError = (error: string) => {
    throw new Error(error);
  };

  return { throwError };
}
